import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';

import { UserService } from 'src/app/services/shared/user.service';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { RoutingService } from 'src/app/services/routing.service';
import { CustomValidators } from 'src/app/shared/validators/custom.validators';
import { AppSettingsService, SubdomainEnum } from 'src/app/services/app-settings.service';

@Component({
  selector: 'terra-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})
export class EmailVerificationComponent implements OnInit {

  isSendingEmail = false;

  resendSuccessful = false;
  hasError = false;

  clientDetails$ = this.userService.accountDetails$;

  pageForm: UntypedFormGroup;

  paths = TerraUtils.consts.paths;
  firstTime = true;

  referrerLogo$ = this.appSettingsService.subDomain === SubdomainEnum.GP ? this.userService.gp_referrerLogo$ : this.userService.lp_referrerLogo$;

  constructor(
    private fb: UntypedFormBuilder,
    public routingService: RoutingService,
    private titleService: Title,
    private userService: UserService,
    private appSettingsService: AppSettingsService) { }

  ngOnInit() {
    this.titleService.setTitle('Verify Your Email');
    this.pageForm = this.fb.group({
      email: ['', [Validators.required, CustomValidators.EmailWithSpaces]],
      password: ['', [Validators.required]]
    });

    this.userService.accountDetails$.subscribe(clientDetails => {
      this.pageForm.get('email').patchValue(clientDetails.email);
    });

    this.resendConfirmationEmail(false);
  }

  resendConfirmationEmail(overrideCounter = false) {

    this.hasError = false;
    this.resendSuccessful = false;

    this.isSendingEmail = true;

    this.userService
      .resendConfirmationEmail(overrideCounter)
      .subscribe(
        response => {
          this.isSendingEmail = false;
          if (this.firstTime) {
            this.firstTime = false;
          } else {
            this.resendSuccessful = true;
          }
        },
        error => {
          this.isSendingEmail = false;
          this.hasError = true;
        }
      );
  }
}
